import React from 'react';
import { BEAT, keywords } from '../../data/reel';
import { SceneProps } from '../../types/reel';
import { easeOut, progress } from '../../utils/reelMath';
import { SceneLayer } from './SceneLayer';

/** One keyword per beat, hard cuts alternating ink and cream. */
export function KeywordsScene({
  time,
  scene
}: SceneProps) {
  return <SceneLayer time={time} start={scene.start} end={scene.end} fade={0.08} data-id="element-84" data-mp="3vzw2i6rjm85h">
      {({
      local
    }) => {
      const index = Math.min(keywords.length - 1, Math.max(0, Math.floor(local / BEAT)));
      const at = scene.start + index * BEAT;
      const settle = easeOut(progress(time, at, at + 0.28));
      const dark = index % 2 === 0;
      return <div className={`absolute inset-0 flex items-center justify-center ${dark ? 'bg-ink' : 'bg-cream'}`} data-id="element-85" data-mp="is2ixqluhnnm">
            <p className={`whitespace-nowrap font-medium leading-none ${dark ? 'text-cream' : 'text-ink'}`} style={{
          fontSize: Math.min(160, 1620 / (keywords[index].length * 0.6)),
          transform: `scale(${1.08 - 0.08 * settle})`,
          letterSpacing: `${-0.015 - 0.03 * settle}em`,
          filter: `blur(${(1 - settle) * 5}px)`
        }} data-id="element-86" data-mp="16hdkvbexlo3c">
              {keywords[index]}
            </p>
          </div>;
    }}
    </SceneLayer>;
}